import { dataProvider } from '@/services/data-provider';
import { GetConversationsParams } from '../conversations/conversations.types';
import { tryCatch } from '@/services/api-client';
import { User } from './users.types';

export const getUsersList = async ({
  filter,
  sort,
  order,
  perPage,
  page,
}: GetConversationsParams) => {
  const { data: response, error } = await tryCatch(
    dataProvider.getList<User>('users', {
      pagination: { page: page || 1, perPage: perPage || 10 },
      sort: { field: sort || 'updated_at', order: order || 'DESC' },
      filter,
    }),
  );

  if (error) {
    throw error;
  }

  return response;
};

export const createUser = async (userData: Partial<User>) => {
  const { data: response, error } = await tryCatch(
    dataProvider.create<User>('users', { data: userData }),
  );

  if (error) {
    throw error;
  }

  return response;
};
